import { publicAPI } from 'shared/utils/ajax';

const path = `/annon/web`;

export const getInherenceKey$ = () => publicAPI.get(`${path}/key`);
